var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutus"},[_c('SectionHeader',{attrs:{"title":"Quienes somos"}}),_vm._v(" Quienes somos ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }